import { useState, useEffect } from "react";
import calculatePopoverPosition from "./popover-position-util";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";

export const useDashboardTimeseriesPopover = (
  popoverRef,
  popoverContentRef,
  texts,
) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [popoverStyle, setPopoverStyle] = useState({});

  const handleClickOnInfo = () => {
    setIsPopoverOpen((prev) => !prev);
  };
  useClickOutsideListener(popoverRef, handleClickOnInfo, isPopoverOpen);

  useEffect(() => {
    if (isPopoverOpen && popoverRef.current && popoverContentRef.current) {
      const style = calculatePopoverPosition(popoverRef, popoverContentRef);
      if (style) setPopoverStyle(style);
    }
  }, [isPopoverOpen, popoverRef, popoverContentRef]);

  const copyToClipboard = async (text: string, typeLabel: string) => {
    try {
      await navigator.clipboard.writeText(text);
      successSnackbar(`${typeLabel} ${texts.successMessage}`);
    } catch (err) {
      errorSnackbar(`${texts.errorMessage}: ${err}`, 5000);
    }
  };

  const copyNodeIdToClipBoard = async (text: string, typeLabel: string) => {
    copyToClipboard(text, typeLabel);
  };
  return {
    isPopoverOpen,
    popoverStyle,
    handleClickOnInfo,
    copyNodeIdToClipBoard,
  };
};
